import fp from 'lodash/fp';
import { combineActions, handleActions } from 'redux-actions';
import { actions } from './actions';

export const initialState = {
  team: {
    error: undefined,
    isUpdating: false,
    currentTeam: undefined,
    isFetchingTeamCpdCategorys: false,
    industryRoles: [],
    isFetchingTeamIndustryRoles: false,
    isFetchingPendingExternalCpd: false,
    isSettingTeams: false,
    isFetchingTeam: false,
    setTeamTrainingPlanSuccess: undefined
  }
}

export const reducerDefinition = {
  [actions.business.team.api.updateIndustryRole.success]: ({ team, ...state }, { payload: { industryRole } }) => ({
    ...state,
    team: {
      ...team,
      industryRoles: fp.concat(
        fp.filter(({ id }) => id !== industryRole.id)(state.industryRoles),
        industryRole
      )
    }
  }),
  [actions.business.team.api.getTeams.request]: ({ ...state }) => ({
    ...state,
    isFetchingTeams: true
  }),
  [actions.business.team.api.getTeams.failed]: ({ ...state }, action) => ({
    ...state,
    isFetchingTeams: false
  }),
  [actions.business.team.api.getTeams.success]: ({ ...state }, { payload: teams }) => ({
    ...state,
    isFetchingTeams: false,
    teams: teams.teams
  }),
  [actions.business.team.api.loadMoreTeams.request]: ({ ...state }) => ({
    ...state,
    isFetchingTeams: true
  }),
  [actions.business.team.api.loadMoreTeams.failed]: ({ ...state }, action) => ({
    ...state,
    isFetchingTeams: false
  }),
  [actions.business.team.api.loadMoreTeams.success]: ({ ...state }, { payload: teams }) => ({
    ...state,
    isFetchingTeams: false,
    teams: {
      ...teams.teams,
      businessTeams: state.teams.businessTeams.concat(teams.teams.businessTeams)
    }
  }),
  [actions.business.team.api.getTeamsWithStats.request]: ({ ...state }) => ({
    ...state,
    isFetchingTeamsWithStats: true,
  }),
  [actions.business.team.api.getTeamsWithStats.failed]: ({ ...state }, action) => ({
    ...state,
    isFetchingTeamsWithStats: false
  }),
  [actions.business.team.api.getTeamsWithStats.success]: ({ ...state }, { payload: teams }) => ({
    ...state,
    isFetchingTeamsWithStats: false,
    teamsWithStats: teams.teamsWithStats
  }),
  [actions.business.team.api.loadMoreTeamsWithStats.request]: ({ ...state }) => ({
    ...state,
    isFetchingTeamsWithStats: true
  }),
  [actions.business.team.api.loadMoreTeamsWithStats.failed]: ({ ...state }, action) => ({
    ...state,
    isFetchingTeamsWithStats: false
  }),
  [actions.business.team.api.loadMoreTeamsWithStats.success]: ({ ...state }, { payload: teams }) => ({
    ...state,
    isFetchingTeamsWithStats: false,
    teamsWithStats: {
      ...teams.teamsWithStats,
      businessTeams: state.teamsWithStats.businessTeams.concat(teams.teamsWithStats.businessTeams)
    }
  }),
  [actions.business.team.api.getTeamsWithProgress.request]: ({ ...state }) => ({
    ...state,
    isFetchingTeamsWithProgress: true,
  }),
  [actions.business.team.api.getTeamsWithProgress.failed]: ({ ...state }, action) => ({
    ...state,
    isFetchingTeamsWithProgress: false
  }),
  [actions.business.team.api.getTeamsWithProgress.success]: ({ ...state }, { payload: teams }) => ({
    ...state,
    isFetchingTeamsWithProgress: false,
    teamsWithProgress: teams.teamsWithProgress
  }),
  [actions.business.team.api.loadMoreTeamsWithProgress.request]: ({ ...state }) => ({
    ...state,
    isFetchingTeamsWithProgress: true
  }),
  [actions.business.team.api.loadMoreTeamsWithProgress.failed]: ({ ...state }, action) => ({
    ...state,
    isFetchingTeamsWithProgress: false
  }),
  [actions.business.team.api.loadMoreTeamsWithProgress.success]: ({ ...state }, { payload: teams }) => ({
    ...state,
    isFetchingTeamsWithProgress: false,
    teamsWithProgress: {
      ...teams.teamsWithProgress,
      businessTeamsWithProgress: state.teamsWithProgress.businessTeamsWithProgress.concat(teams.teamsWithProgress.businessTeamsWithProgress)
    }
  }),
  [actions.business.team.api.getTeam.request]: ({ ...state }) => ({
    ...state,
    isFetchingTeams: true,
    team: {
      ...state.team,
      error: null
    }
  }),
  [actions.business.team.api.getTeam.failed]: ({ ...state }, action) => ({
    ...state,
    isFetchingTeams: false,
    team: {
      ...state.team,
      error: action.payload.error
    }
  }),
  [actions.business.team.api.getTeam.success]: ({ ...state }, { payload: { team } }) => ({
    ...state,
    isFetchingTeams: false,
    team: {
      ...state.team,
      currentTeam: team,
      error: null
    }
  }),
  [actions.business.team.api.getTeamStats.request]: ({ ...state }, action) => ({
    ...state,
    isFetchingTeams: true,
    team: {
      ...state.team,
      error: null
    }
  }),
  [actions.business.team.api.getTeamStats.failed]: ({ ...state }, action) => ({
    ...state,
    isFetchingTeams: false,
    team: {
      ...state.team,
      error: action.payload.error
    }
  }),
  [actions.business.team.api.getTeamStats.success]: ({ ...state }, { payload: { teamStats } }) => ({
    ...state,
    isFetchingTeams: false,
    team: {
      ...state.team,
      currentTeamStats: teamStats
    }
  }),
  [actions.business.team.api.getTeamMembers.request]: ({ ...state }) => ({
    ...state,
    isFetchingMembers: true,
    team: {
      ...state.team,
      error: null
    }
  }),
  [actions.business.team.api.getTeamMembers.failed]: ({ ...state }, action) => ({
    ...state,
    isFetchingMembers: false,
    team: {
      ...state.team,
      error: action.payload.error
    }
  }),
  [actions.business.team.api.getTeamMembers.success]: ({ ...state }, { payload: { teamMembers } }) => ({
    ...state,
    isFetchingMembers: false,
    team: {
      ...state.team,
      currentTeamMembers: teamMembers
    }
  }),
  [actions.business.team.api.getNonMemberManagers.request]: ({ ...state }) => ({
    ...state,
    isFetchingManagers: true,
    team: {
      ...state.team,
      error: null
    }
  }),
  [actions.business.team.api.getNonMemberManagers.failed]: ({ ...state }, action) => ({
    ...state,
    isFetchingManagers: false,
    team: {
      ...state.team,
      error: action.payload.error
    }
  }),
  [actions.business.team.api.getNonMemberManagers.success]: ({ ...state }, { payload: { nonMemberManagers } }) => ({
    ...state,
    isFetchingManagers: false,
    team: {
      ...state.team,
      currentTeamNonMemberManagers: nonMemberManagers
    }
  }),
  [actions.business.team.api.loadMoreMembers.request]: ({ ...state }) => ({
    ...state,
    isFetchingMembers: true,
    team: {
      ...state.team,
      error: null
    }
  }),
  [actions.business.team.api.loadMoreMembers.failed]: ({ ...state }, action) => ({
    ...state,
    isFetchingMembers: false,
    team: {
      ...state.team,
      error: action.payload.error
    }
  }),
  [actions.business.team.api.loadMoreMembers.success]: ({ ...state }, { payload: { teamMembers } }) => ({
    ...state,
    isFetchingMembers: false,
    team: {
      ...state.team,
      currentTeamMembers: {
        hits: teamMembers.hits,
        teamMembers: state.team.currentTeamMembers.teamMembers.concat(teamMembers.teamMembers),
        memberStats: state.team.currentTeamMembers.memberStats.concat(teamMembers.memberStats)
      }
    }
  }),
  [actions.business.team.api.createTeam.request]: ({ ...state }) => ({
    ...state,
    isFetchingTeams: true,
    team: {
      ...state.team,
      error: null
    }
  }),
  [actions.business.team.api.createTeam.failed]: ({ ...state }, action) => ({
    ...state,
    isFetchingTeams: false,
    team: {
      ...state.team,
      error: action.payload.error
    }
  }),
  [actions.business.team.api.createTeam.success]: ({ ...state }) => ({
    ...state,
    isFetchingTeams: false,
    team: {
      ...state.team,
      error: null
    }
  }),
  [actions.business.team.api.removeTeam.request]: ({ ...state }) => ({
    ...state,
    isFetchingTeams: true,
    team: {
      ...state.team,
      error: null
    }
  }),
  [actions.business.team.api.removeTeam.failed]: ({ ...state }, action) => ({
    ...state,
    isFetchingTeams: false,
    team: {
      ...state.team,
      error: action.payload.error
    }
  }),
  [actions.business.team.api.removeTeam.success]: ({ ...state }) => ({
    ...state,
    isFetchingTeams: false,
    team: {
      ...state.team,
      error: null
    }
  }),
  [actions.business.team.api.renameTeam.request]: ({ ...state }) => ({
    ...state,
    isFetchingTeams: true,
    team: {
      ...state.team,
      error: null
    }
  }),
  [actions.business.team.api.renameTeam.failed]: ({ ...state }, action) => ({
    ...state,
    isFetchingTeams: false,
    team: {
      ...state.team,
      error: action.payload.error
    }
  }),
  [actions.business.team.api.renameTeam.success]: ({ ...state }, { payload: { team } }) => ({
    ...state,
    isFetchingTeams: false,
    team: {
      ...state.team,
      currentTeam: {
        ...state.team.currentTeam,
        businessTeam: team
      },
      error: null
    }
  }),
  [actions.business.team.api.setTeamMembers.request]: ({ ...state }) => ({
    ...state,
    isSettingTeams: true
  }),
  [actions.business.team.api.setTeamMembers.failed]: ({ ...state }, action) => ({
    ...state,
    isSettingTeams: false
  }),
  [actions.business.team.api.setTeamMembers.success]: ({ ...state }, { payload: { team } }) => ({
    ...state,
    isSettingTeams: false
  }),
  [actions.business.team.api.setManagers.request]: ({ ...state }) => ({
    ...state,
    isSettingTeams: true
  }),
  [actions.business.team.api.setManagers.failed]: ({ ...state }, action) => ({
    ...state,
    isSettingTeams: false
  }),
  [actions.business.team.api.setManagers.success]: ({ ...state }, action) => ({
    ...state,
    isSettingTeams: false
  }),
  [actions.business.team.api.setNonMemberManagers.request]: ({ ...state }) => ({
    ...state,
    isSettingTeams: true
  }),
  [actions.business.team.api.setNonMemberManagers.failed]: ({ ...state }, action) => ({
    ...state,
    isSettingTeams: false
  }),
  [actions.business.team.api.setNonMemberManagers.success]: ({ ...state }, action) => ({
    ...state,
    isSettingTeams: false
  }),
  [actions.business.team.api.getTeamIndustryRoles.request]: (state) => ({
    ...state,
    team: {
      ...state.team,
      isFetchingTeamIndustryRoles: true,
      error: null
    }
  }),
  [actions.business.team.api.getTeamIndustryRoles.success]: (state, action) => ({
    ...state,
    team: {
      ...state.team,
      isFetchingTeamIndustryRoles: false,
      industryRoles: action.payload.industryRoles,
      error: null
    }
  }),
  [actions.business.team.api.getTeamIndustryRoles.failed]: (state, action) => ({
    ...state,
    team: {
      ...state.team,
      isFetchingTeamIndustryRoles: false,
      error: action.payload.error
    }
  }),
  [actions.business.team.api.getTeamTrainingPlan.request]: (state) => ({
    ...state,
    team: {
      ...state.team,
      isFetchingTeamCpdCategorys: true,
      error: null
    }
  }),
  [actions.business.team.api.getTeamTrainingPlan.success]: (state, action) => ({
    ...state,
    team: {
      ...state.team,
      isFetchingTeamCpdCategorys: false,
      trainingPlan: action.payload.trainingPlan,
      error: null
    }
  }),
  [actions.business.team.api.getTeamTrainingPlan.failed]: (state, action) => ({
    ...state,
    team: {
      ...state.team,
      isFetchingTeamCpdCategorys: false,
      error: action.payload.error
    }
  }),
  [actions.business.team.api.setTeamTrainingPlan.request]: (state) => ({
    ...state,
    team: {
      ...state.team,
      isUpdating: true,
      setTeamTrainingPlanSuccess: undefined,
      error: null
    }
  }),
  [actions.business.team.api.setTeamTrainingPlan.success]: (state, action) => ({
    ...state,
    team: {
      ...state.team,
      isUpdating: false,
      trainingPlan: action.payload.trainingPlan,
      setTeamTrainingPlanSuccess: { success: true, info: 'Training Plan Updated' },
      error: null
    }
  }),
  [actions.business.team.api.setTeamTrainingPlan.failed]: (state, action) => ({
    ...state,
    team: {
      ...state.team,
      isUpdating: false,
      setTeamTrainingPlanSuccess: { success: false, info: 'Training Plan Update Failed' },
      error: action.payload.error
    }
  }),
  [actions.business.team.api.getTeamCpdCategorys.request]: (state, action) => ({
    ...state,
    team: {
      ...state.team,
      isFetchingTeamCpdCategorys: true,
      error: null
    }
  }),
  [actions.business.team.api.getTeamCpdCategorys.success]: (state, action) => ({
    ...state,
    team: {
      ...state.team,
      isFetchingTeamCpdCategorys: false,
      cpdCategorys: action.payload.cpdCategorys,
      error: null
    }
  }),
  [actions.business.team.api.getTeamCpdCategorys.failed]: (state, action) => ({
    ...state,
    team: {
      ...state.team,
      isFetchingTeamCpdCategorys: false,
      error: action.payload.error
    }
  }),
  [actions.business.team.api.getTeamPendingExternalCpd.request]: (state, action) => ({
    ...state,
    team: {
      ...state.team,
      isFetchingPendingExternalCpd: true,
      error: null
    }
  }),
  [actions.business.team.api.getTeamPendingExternalCpd.success]: (state, action) => ({
    ...state,
    team: {
      ...state.team,
      isFetchingPendingExternalCpd: false,
      pendingExternalCpd: action.payload.externalCpd,
      error: null
    }
  }),
  [actions.business.team.api.getTeamPendingExternalCpd.failed]: (state, action) => ({
    ...state,
    team: {
      ...state.team,
      isFetchingPendingExternalCpd: false,
      error: action.payload.error
    }
  }),
  [combineActions(actions.business.team.api.addTeamManager.request,
    actions.business.team.api.addTeamManager.success,
    actions.business.team.api.addTeamManager.failed,
    actions.business.team.api.removeTeamManager.request,
    actions.business.team.api.removeTeamManager.success,
    actions.business.team.api.removeTeamManager.failed,
    actions.business.team.api.removeTeamMember.request,
    actions.business.team.api.removeTeamMember.success,
    actions.business.team.api.removeTeamMember.failed,
    actions.business.team.api.addTeamMembers.request,
    actions.business.team.api.addTeamMembers.success,
    actions.business.team.api.addTeamMembers.failed,
    actions.business.team.api.updateIndustryRole.request,
    actions.business.team.api.updateIndustryRole.success,
    actions.business.team.api.updateIndustryRole.failed)]: (state, action) => ({
      ...state
    })
}

export default handleActions(reducerDefinition, { ...initialState });


// WEBPACK FOOTER //
// ./src/state/modules/business/team/reducers.js